import { render, staticRenderFns } from "./IconStatusAuditoria.vue?vue&type=template&id=794ade88&scoped=true"
import script from "./IconStatusAuditoria.vue?vue&type=script&lang=js"
export * from "./IconStatusAuditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794ade88",
  null
  
)

export default component.exports